module.exports = __webpack_public_path__ + "static/media/__video.b105e9ba.svg";